import { useAppSelector, useAppDispatch } from '../../app/redux/hooks'
import { Outlet } from 'react-router-dom'
import {
    HeaderStandard,
    FooterStandard,
    ModalStandard,
    SkipLinkStandard,
    CookieBanner,
    useCookieConsent,
    IAppSettings,
    IAppSettingsCookies,
} from 'optimized-react-component-library-xyz123'
import { toggleSiteImproveScript } from '../../app/script/siteimprove'
import { useState } from 'react'
import { selectGlobalLanguageState, setActivatedLanguage } from '../../app/redux/globalLanguage.Slice'
import appSettingsJson from '../../app/content/content.settings.json'
import 'optimized-react-component-library-xyz123/css/styles.css'
import 'optimized-react-component-library-xyz123/css/questions.css'
import 'optimized-react-component-library-xyz123/css/mobileView.css'
import 'optimized-react-component-library-xyz123/css/darkMode.css'

const RootLayout = () => {
    const dispatch = useAppDispatch()
    const settingsFromJson = (appSettingsJson ?? {}) as Partial<IAppSettings>
    const appUsesLanguage: boolean = settingsFromJson?.appUsesLanguage ?? false
    const appUsesNavigation: boolean = settingsFromJson?.appUsesLanguage ?? false
    const cookieSettings: IAppSettingsCookies = {
        useCookies: settingsFromJson.appCookies?.useCookies ?? false,
        cookieName: settingsFromJson.appCookies?.cookieName ?? '',
        cookieChoiseKey: settingsFromJson.appCookies?.cookieChoiseKey ?? '',
    }
    const { activatedLanguage } = useAppSelector(selectGlobalLanguageState)
    const [showModal, setShowModal] = useState(false)

    const openFormStatusModal = () => {
        setShowModal(true)
    }
    const closeFormStatusModal = () => {
        setShowModal(false)
    }
    const changeLanguageInHeader = (language: string) => {
        dispatch(setActivatedLanguage(language))
    }
    // const { showBanner, handleCookieStateChange, acceptCookies, rejectCookies } = useCookieConsent({
    //     cookieName: cookieSettings.cookieName,
    //     choiceKey: cookieSettings.cookieChoiseKey,
    //     expiryYears: 1,
    //     onConsentChange: toggleSiteImproveScript,
    // })
    return (
        <>
            {cookieSettings.useCookies && (
                <CookieBanner
                    visible={false}
                    onCookieStateChange={() => {}}
                    rejectCookies={() => {}}
                    acceptCookies={() => {}}
                    activatedLanguage={activatedLanguage}
                />
            )}
            <SkipLinkStandard activatedLanguage={activatedLanguage} />
            <ModalStandard showModal={showModal} activatedLanguage={activatedLanguage} />

            <HeaderStandard
                activatedLanguage={activatedLanguage}
                SetActivatedLanguage={changeLanguageInHeader}
                useLanguage={appUsesLanguage}
            />

            <main id="main-content">
                <Outlet context={[openFormStatusModal, closeFormStatusModal]} />
            </main>

            <FooterStandard activatedLanguage={activatedLanguage} />
        </>
    )
}

export default RootLayout
